import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import StatusContainer from './StatusContainer';
import TypologiesAccordion from './TypologiesAccordion';

const ListTypologies = ({
  executed,
  typologiesList = [],
  liveSets,
  typologySets,
  setTypologySets,
  scenarioId,
  setLoading,
  dynpropsTabAccess,
  configureRunInstanceActions
}) => {
  const noOfSetsSelcted = useMemo(() => {
    const sets = new Set();
    typologySets.forEach((t) => {
      if (executed) {
        t.segmentCombinationIds.forEach((s) => sets.add(s));
      } else {
        t.segmentCombinationIds.forEach((s) =>
          liveSets?.data?.combinations?.some((c) => c.id === s) && !sets.has(s)
            ? sets.add(s)
            : null
        );
      }

      // validate if default set is selected
      if (t?.useDefault && !sets.has('default')) sets.add('default');
    });
    return Array.from(sets).length;
  }, [typologySets, liveSets]);

  const noOfUnassigned = useMemo(() => {
    if (executed) {
      return typologySets.filter(
        (t) => t.segmentCombinationIds.length === 0 && !t.useDefault
      ).length;
    } else {
      return typologySets.filter(
        (t) =>
          liveSets?.data?.combinations?.filter((c) =>
            t.segmentCombinationIds.includes(c.id)
          ).length === 0 && !t.useDefault
      ).length;
    }
  }, [typologySets, liveSets]);

  return (
    <div>
      <StatusContainer
        typoNo={typologySets?.length}
        sets={noOfSetsSelcted}
        noOfUnassigned={noOfUnassigned}
      />
      {typologiesList?.map((typology) => {
        if (typologySets.some((f) => f.typologyId === typology.typology.id)) {
          return (
            <TypologiesAccordion
              key={typology.typology.id}
              executed={executed}
              typologyData={typology}
              liveSets={liveSets}
              typologySets={typologySets}
              scenarioId={scenarioId}
              setLoading={setLoading}
              setTypologySets={setTypologySets}
              dynpropsTabAccess={dynpropsTabAccess}
              configureRunInstanceActions={configureRunInstanceActions}
            />
          );
        } else {
          return;
        }
      })}
    </div>
  );
};

ListTypologies.propTypes = {
  typologiesList: PropTypes.array,
  liveSets: PropTypes.object,
  typologySets: PropTypes.array,
  setTypologySets: PropTypes.func,
  scenarioId: PropTypes.number,
  setLoading: PropTypes.func,
  dynpropsTabAccess: PropTypes.bool,
  executed: PropTypes.bool,
  configureRunInstanceActions: PropTypes.object
};

export default ListTypologies;
